import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FOComponent } from './fo.component';
import { HomeComponent } from './home/home.component';
import { EventComponent } from './event/event.component';
import { BookingComponent } from './booking/booking.component';
import { BookingInfosComponent } from './booking/booking-infos/booking-infos.component';
import { BookingConfirmComponent } from './booking/booking-confirm/booking-confirm.component';
import { BookingPaymentComponent } from './booking/booking-payment/booking-payment.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { FormsModule } from "@angular/forms";
import { LandingProComponent } from './landing/landing-pro/landing-pro.component';
import { AccountComponent } from './account/account.component';
import { AccountService } from './account/account.service';
import { ProfileComponent } from './account/profile/profile.component';
import { TicketsComponent } from './account/tickets/tickets.component';
import { CategoriesComponent } from './home/categories/categories.component';
import { CguComponent } from './cgu/cgu.component';
import { SharedModule } from '../shared/shared.module';
import {WeekPipe} from "./home/week.pipe";
import {AgmCoreModule} from "@agm/core";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CgComponent } from './cg/cg.component';
import { MentionsLegalesComponent } from './mentions-legales/mentions-legales.component';
import { FaqComponent } from './faq/faq.component';
import { JoinUsComponent } from './join-us/join-us.component';
import { SolutionsComponent } from './page/solutions/solutions.component';
import { ContactFormModalComponent } from './contact-form-modal/contact-form-modal.component';
import {FoEventsService} from "./event/foevents.service";
import {AuthService} from "../core/auth/auth.service";
import { PricingHeaderComponent } from './event/pricing-header/pricing-header.component';
import { PricingStatutComponent } from './event/pricing-statut/pricing-statut.component';
import { RegistrationInputComponent } from './booking/booking-infos/registration-input/registration-input.component';
import { PricingShowComponent } from './event/pricing-show/pricing-show.component';
import { EventInscriptionComponent } from './event-inscription/event-inscription.component';
import { InscriptionEndComponent } from './event-inscription/inscription-end/inscription-end.component';
import { PaymentSuccessComponent } from './event-inscription/payment-success/payment-success.component';
import { PaymentConfirmComponent } from './event-inscription/payment-confirm/payment-confirm.component';
import { CountDownComponent } from './booking/count-down/count-down.component';
import { LinksComponent } from './links/links.component';
import { OrderShowComponent } from './account/tickets/order-show/order-show.component';
import { BookingDeadlinePaymentComponent } from './booking/booking-deadline-payment/booking-deadline-payment.component';
import { BookingHousingComponent } from './booking/booking-housing/booking-housing.component';
import { PreAccountInputsComponent } from './booking/pre-account-inputs/pre-account-inputs.component';
import {ShareModule} from "ngx-sharebuttons";
import {ShareIconsModule} from "ngx-sharebuttons/icons";
import {NgxSocialShareModule} from "ngx-social-share";
import { EventFrameComponent } from './event-frame/event-frame.component';
import {FoRoutingModule} from "./fo-routing.module";
import {CoreModule} from "../core/core.module";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {translateBrowserLoaderFactory} from "../translate-browser.loader";
import {HttpClient} from "@angular/common/http";
import {TransferState} from "@angular/platform-browser";
import { HandleTokenComponent } from './handle-token/handle-token.component';
import {ImageCropperComponent} from "ngx-image-cropper";

@NgModule({
  imports: [
    TranslateModule.forRoot({
      defaultLanguage: 'fr',
      loader: {
        provide: TranslateLoader,
        useFactory: translateBrowserLoaderFactory,
        deps: [HttpClient, TransferState]
      }
    }),
    FoRoutingModule,CoreModule,
    SharedModule,CommonModule,ShareIconsModule,NgxSocialShareModule,ShareModule, ShareIconsModule, CommonModule, RouterModule,FormsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBOWus4r7K7tQeCND85-segcBkIic07yTI'
    }),
    NgbModule,
  ],
  declarations: [
    HomeComponent,
    FOComponent,
    EventComponent,
    BookingComponent,
    BookingInfosComponent,
    BookingConfirmComponent,
    BookingPaymentComponent,
    HeaderComponent,
    FooterComponent,
    LandingProComponent,
    AccountComponent,
    ProfileComponent,
    TicketsComponent,
    CategoriesComponent,
    WeekPipe,
    CguComponent,
    CgComponent,
    MentionsLegalesComponent,
    FaqComponent,
    JoinUsComponent,
    SolutionsComponent,
    ContactFormModalComponent,
    PricingHeaderComponent,
    PricingStatutComponent,
    RegistrationInputComponent,
    PricingShowComponent,
    EventInscriptionComponent,
    InscriptionEndComponent,
    PaymentSuccessComponent,
    PaymentConfirmComponent,
    CountDownComponent,
    LinksComponent,
    OrderShowComponent,
    BookingDeadlinePaymentComponent,
    BookingHousingComponent,
    PreAccountInputsComponent,
    EventFrameComponent,
    HandleTokenComponent
  ],
  providers: [
    AccountService,FoEventsService,AuthService
  ]
})
export class FOModule {}
